import { Pipe, PipeTransform } from '@angular/core';

import { memoize } from '../../../../decorators/memoize.decorator';

@Pipe({
  standalone: false,
  name: 'highlight',
})
export class HighlightSearch implements PipeTransform {
  transform(value: any, args: any = ''): any {
    if (value && args) {
      return this.highlight(value, args);
    }
    return value;
  }

  @memoize()
  highlight(value, args): string {
    const modifiedValue = this.excludeUmlauts(value);
    const modifiedArgs = this.excludeUmlauts(args);
    const re = new RegExp(modifiedArgs, 'gi');
    const foundIndex = modifiedValue.search(re);

    if (foundIndex >= 0) {
      const currentValue = value;
      const argsValue = currentValue.slice(foundIndex, foundIndex + args.length);

      return modifiedValue.replace(re, `<span class='highlight'>${argsValue}</span>`);
    }

    return value;
  }

  @memoize()
  excludeUmlauts(input: string): string {
    if (!this.stringHasSpecialCharacter(input)) {
      return input;
    }

    let modifiedInput = input;
    const charLib = {
      A: ['À', 'Á', 'Â', 'Ã', 'Ä'],
      C: ['Ç'],
      E: ['È', 'É', 'Ê', 'Ë'],
      I: ['Ì', 'Í', 'Î', 'Ï'],
      N: ['Ñ'],
      O: ['Ò', 'Ó', 'Ô', 'Õ', 'Ö'],
      S: ['Š'],
      U: ['Ú', 'Û', 'Ü', 'Ù'],
      Y: ['Ý', 'Ÿ'],
      Z: ['Ž'],
      a: ['à', 'á', 'â', 'ã', 'ä'],
      c: ['ç'],
      e: ['è', 'é', 'ê', 'ë'],
      i: ['ì', 'í', 'î', 'ï'],
      n: ['ñ'],
      o: ['ò', 'ó', 'ô', 'õ', 'ö'],
      s: ['š'],
      u: ['ù', 'ú', 'û', 'ü'],
      y: ['ý', 'ÿ'],
      z: ['ž'],
    };

    // eslint-disable-next-line no-restricted-syntax
    for (const key in charLib) {
      // eslint-disable-next-line no-prototype-builtins
      if (charLib.hasOwnProperty(key)) {
        const characters = charLib[key];

        // eslint-disable-next-line @typescript-eslint/no-loop-func
        characters.forEach((character: string) => {
          if (modifiedInput.includes(character)) {
            modifiedInput = modifiedInput.replace(character, key);
          }
        });
      }
    }

    return modifiedInput;
  }

  @memoize()
  stringHasSpecialCharacter(input): boolean {
    const specialSymbols = /[à-žÀ-Ž]/;

    return specialSymbols.test(input);
  }
}
